/* eslint-disable no-unused-vars */
export enum EProfile {
  admin = 'admin',
  lawyer = 'lawyer',
  attendant = 'attendant',
  financial = 'financial',
}
